<script setup lang="ts">
import { cn } from '@/lib/utils';

import { ChevronDownIcon } from '@heroicons/vue/outline';
import { NavigationMenuTrigger, type NavigationMenuTriggerProps, useForwardProps } from 'reka-ui';
import { computed, type HTMLAttributes } from 'vue';
import { navigationMenuTriggerStyle } from '.';

const props = defineProps<NavigationMenuTriggerProps & { class?: HTMLAttributes['class'] }>();

const delegatedProps = computed(() => {
  const { class: _, ...delegated } = props;

  return delegated;
});

const forwardedProps = useForwardProps(delegatedProps);
</script>

<template>
  <NavigationMenuTrigger
    v-bind="forwardedProps"
    :class="
      cn(
        navigationMenuTriggerStyle(),
        'group/test relative font-heading tracking-heading transition-colors data-[active=true]:bg-anti-flash-white data-[state=open]:bg-anti-flash-white',
        props.class
      )
    "
  >
    <span
      class="ease absolute left-0 right-0 top-0 h-[3px] origin-top scale-x-0 bg-tangerine transition-transform duration-500 group-hover/test:origin-top group-hover/test:scale-x-100 group-data-[active=true]:scale-x-100 group-data-[state=open]:scale-x-100"
    ></span>
    <slot />
    <ChevronDownIcon
      class="relative top-px ml-2 size-3 stroke-3 transition duration-200 group-data-[state=open]:rotate-180"
      aria-hidden="true"
    />
  </NavigationMenuTrigger>
</template>
